// extracted by mini-css-extract-plugin
export default {"container":"HY-z","list":"IY-z"};